import React from 'react';
import './Blog.css'





const Blog = () => {
    return ( 

    <>



<section id="blog" data-stellar-background-ratio="0.5">
          <div class="container">
               <div class="row">

                    <div class="col-md-12 col-sm-12">
                         <div class="section-title" data-aos="fade-up">
                              <h2>Our Blog</h2>
                              <span class="line-bar">...</span>
                         </div>
                    </div>

                    <div class="col-md-6 col-sm-6" data-aos="fade-up" data-aos-delay="50">
                         
                         <div class="media blog-thumb">
                              <div class="media-object media-left">
                                   <a href="blog-detail.html"><img src={"images/blog/pe.png"} class="img-responsive" alt=""/></a>
                              </div>
                              <div class="media-body blog-info">
                                   <small><i class="fa fa-clock-o"></i> septemmber 20, 2019</small>
                                   <h3><a href="blog-detail.html">we make local games our top priority.</a></h3>
                                   <p sec-text>Lorem ipsum dolor sit consectetur adipiscing morbi venenatis.</p>
                                   <a href="blog-detail.html" class="btn section-btn">Read article</a>
                              </div>
                         </div>
                    </div>

                    <div class="col-md-6 col-sm-6" data-aos="fade-up" data-aos-delay="50">
                         
                         <div class="media blog-thumb">
                              <div class="media-object media-left">
                                   <a href="blog-detail.html"><img src={"images/blog/best.png"} class="img-responsive" alt=""/></a>
                              </div>
                              <div class="media-body blog-info">
                                   <small><i class="fa fa-clock-o"></i> July 18, 2019</small>
                                   <h3><a href="blog-detail.html">best mathemacians.</a></h3>
                                   <p sec-text>Lorem ipsum dolor sit consectetur adipiscing morbi venenatis.</p>
                                   <a href="blog-detail.html" class="btn section-btn">Read more</a>
                              </div>
                         </div>
                    </div>

                    <div class="col-md-6 col-sm-6" data-aos="fade-up" data-aos-delay="100">
                         
                         <div class="media blog-thumb">
                              <div class="media-object media-left">
                                   <a href="blog-detail.html"><img src={"images/blog/group6.png"} class="img-responsive" alt=""/></a>
                              </div>
                              <div class="media-body blog-info">
                                   <small><i class="fa fa-clock-o"></i> August 14, 2022</small>
                                   <h3><a href="blog-detail.html">nurturing fooball talents.</a></h3>
                                   <p sec-text>Lorem ipsum dolor sit consectetur adipiscing morbi venenatis.</p>
                                   <a href="blog-detail.html" class="btn section-btn">Read article</a>
                              </div>
                         </div>
                    </div>

                    <div class="col-md-6 col-sm-6" data-aos="fade-up" data-aos-delay="100">
                         
                         <div class="media blog-thumb">
                              <div class="media-object media-left">
                                   <a href="blog-detail.html"><img src={"images/blog/covid.png"} class="img-responsive" alt=""/></a>
                              </div>
                              <div class="media-body blog-info">
                                   <small><i class="fa fa-clock-o"></i> December 8, 2020</small>
                                   <h3><a href="blog-detail.html">measures put in place to prevent covid-19.</a></h3>
                                   <p sec-text>Lorem ipsum dolor sit consectetur adipiscing morbi venenatis.</p>
                                   <a href="blog-detail.html" class="btn section-btn">View Detail</a>
                              </div>
                         </div>
                    </div>
                    
               </div>
          </div>
     </section>

    </> 

    );
}
 
export default Blog;